import { LegalPage } from './LegalPage';

export function TermsPage() {
  return (
    <LegalPage
      title="Условия сервиса"
      subtitle="Правила использования lex.ai, работы с юристом, оплаты и возвратов. Редакция от 21 октября 2026 года."
    >
      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">1. О сервисе</h2>
        <p>
          lex.ai — онлайн-сервис юридической помощи призывникам, военнослужащим и их близким. Сервис
          организует переписку с юристом, хранение документов, сроки и статусы обращения. Сервис не
          является медицинской организацией и не заменяет очный приём врача или представительство в
          суде без отдельного договора.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">2. Аккаунт</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>
            войти можно по email; телефон и Telegram используются для уведомлений, если вы их
            указали;
          </li>
          <li>вы отвечаете за доступ к своему номеру, почте и Telegram;</li>
          <li>нельзя передавать аккаунт третьим лицам и создавать аккаунты для спама;</li>
          <li>при подозрении на взлом или мошенничество аккаунт может быть ограничен.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">3. Вопросы и ответы юриста</h2>
        <p>
          Юрист отвечает на основании информации и документов, которые вы предоставили. Неполные или
          недостоверные сведения могут привести к неверному выводу. Ответ носит
          информационно-правовой характер: это разбор ситуации и план действий, а не гарантия
          конкретного решения органов, суда или комиссии.
        </p>
        <p>
          Срок ответа зависит от тарифа и рабочего времени: юристы работают ежедневно с 09:00 до
          21:00 по Москве. Срок может увеличиться, если нужны документы или уточнения.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">4. Тарифы и оплата</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>стоимость и состав тарифа указаны на странице «Тарифы» до оплаты;</li>
          <li>оплата подтверждает заказ выбранного тарифа;</li>
          <li>тариф действует указанный период с момента оплаты;</li>
          <li>автопродление включается только по вашему действию и отключается в кабинете;</li>
          <li>лимиты количества обращений зависят от тарифа и отображаются до оплаты.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">5. Возврат средств</h2>
        <p>
          Запросить возврат можно в кабинете в разделе «Подписка». Мы рассматриваем заявку
          индивидуально: учитываем, был ли ответ юриста, сколько времени прошло с оплаты и какие
          расходы уже понесены. Одобренный возврат направляется тем же способом, которым была
          произведена оплата, в сроки платёжной системы.
        </p>
        <p>
          Если ответ ещё не готов, возврат обычно возможен в полном объёме. Если работа уже
          выполнена, возврат может быть частичным или отклонён — с объяснением причины.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">6. Документы и конфиденциальность</h2>
        <p>
          Перед загрузкой удалите из документов лишние персональные данные: номера карт, пароли,
          сведения, не относящиеся к вопросу. Файлы доступны вам, юристу и сотрудникам, которые
          обеспечивают работу обращения. Удалить файл можно в кабинете; удаление необратимо.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">7. Запрещается</h2>
        <ul className="list-disc space-y-1 pl-5">
          <li>загружать вредоносные файлы и пытаться нарушить работу Сервиса;</li>
          <li>оскорблять юристов и сотрудников, угрожать, публиковать чужие данные;</li>
          <li>использовать Сервис для незаконных действий и обхода закона;</li>
          <li>выдавать себя за другого человека или организацию.</li>
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">8. Ответственность</h2>
        <p>
          Сервис отвечает за организацию работы и достоверность переданной информации в пределах
          оплаченного тарифа. Мы не отвечаем за решения государственных органов, действия третьих
          лиц и последствия, вызванные неполными данными со стороны клиента. При сбоях мы стараемся
          сохранить переписку и восстановить доступ.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-[19px] font-semibold text-ink">9. Изменения и контакты</h2>
        <p>
          Мы можем обновлять Условия: новая редакция публикуется на этой странице с датой. Продолжая
          пользоваться Сервисом после изменений, вы принимаете новую редакцию. Вопросы:{' '}
          <a className="font-semibold text-accent" href="mailto:help@lex.ai">
            help@lex.ai
          </a>
          .
        </p>
      </section>
    </LegalPage>
  );
}
